import { render, staticRenderFns } from "./DetailSaleDownPayment.vue?vue&type=template&id=13c7d37a"
import script from "./DetailSaleDownPayment.vue?vue&type=script&lang=js"
export * from "./DetailSaleDownPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports